// Types for the tenant-facing SMS Credits marketplace page (portal-api /v1/sms-credits/*).
// All money values are integer CENTS.

export type SmsCreditPurchaseSource = 'manual' | 'auto_recharge';
export type SmsCreditPurchaseStatus = 'pending' | 'paid' | 'granted' | 'failed';

export interface ISmsCreditPackage {
    id: string;
    credits: number;
    price: number;
    currency: string;
    isActive: boolean;
    sort: number;
}

export interface ISmsCreditBalance {
    included: number;
    purchased: number;
    available: number;
    includedResetsAt: string | null;
}

export interface ISmsCreditPurchase {
    id: string;
    tenantId: string;
    userId: string;
    packageId: string;
    credits: number;
    amount: number;
    currency: string;
    source: SmsCreditPurchaseSource;
    status: SmsCreditPurchaseStatus;
    finixTransferId: string | null;
    failureReason: string | null;
    grantAttempts: number;
    grantedAt: string | null;
    createdAt: string;
}

export type SmsAutoRechargeFailureCode =
    | 'card_declined'
    | 'no_default_card'
    | 'payer_inactive'
    | 'payment_error'
    | 'package_unavailable'
    | 'package_below_threshold';
export const SMS_AUTO_RECHARGE_FAILURE_CODES: readonly string[] = [
    'card_declined',
    'no_default_card',
    'payer_inactive',
    'payment_error',
    'package_unavailable',
    'package_below_threshold',
];

export interface ISmsAutoRechargeSettings {
    tenantId: string;
    enabled: boolean;
    threshold: number | null;
    packageId: string | null;
    monthlyCap: number | null;
    payerUserId: string | null;
    adminDisabled: boolean;
    adminMaxCap: number | null;
    lastFailure: string | null;
    lastFailureCode: SmsAutoRechargeFailureCode | null;
}

export interface ISmsAutoRechargeUpdate {
    enabled: boolean;
    threshold?: number;
    packageId?: string;
    monthlyCap?: number;
}

export const SMS_AUTO_RECHARGE_THRESHOLDS = [250, 500, 1000, 2500, 5000] as const;
// Preset monthly caps, in cents ($100 / $250 / $500 / $1000 / $2500).
export const SMS_AUTO_RECHARGE_CAP_PRESETS = [10000, 25000, 50000, 100000, 250000] as const;
// Largest catalogue package; anything above is "contact Nuvioo".
export const SMS_MAX_SELF_SERVE_CREDITS = 50000;
